import React from "react";
import { Search } from "lucide-react";

/**
 * Compact emp code / name search input for table toolbars.
 */
export default function EmpCodeNameSearchBar({
  value = "",
  onChange,
  darkMode = false,
  placeholder = "Search code or name…",
  className = "",
  total = null,
  filtered = null,
  showCount = false,
}) {
  const muted = "text-[hsl(var(--ds-muted-fg))]";
  const inputCls = darkMode
    ? "w-full rounded-lg border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-bg))] px-2 py-1.5 text-xs text-[hsl(var(--ds-fg))] placeholder:text-[hsl(var(--ds-muted-fg))] focus:outline-none focus:ring-1 focus:ring-[hsl(var(--ds-primary))]"
    : "w-full rounded-lg border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2 py-1.5 text-xs text-[hsl(var(--ds-fg))] placeholder:text-[hsl(var(--ds-muted-fg))] focus:outline-none focus:ring-1 focus:ring-[hsl(var(--ds-primary))]";

  return (
    <div className={`flex min-w-[160px] flex-1 flex-wrap items-center gap-2 ${className}`}>
      <div className="relative min-w-[12rem] w-full max-w-full flex-1">
        <Search
          className={`pointer-events-none absolute left-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 ${muted}`}
          aria-hidden
        />
        <input
          type="search"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          className={`${inputCls} pl-8`}
          aria-label={placeholder}
        />
      </div>
      {showCount && total != null && (
        <span className={`shrink-0 text-[11px] ${muted}`}>
          Showing{" "}
          <strong className="tabular-nums">{filtered != null ? filtered : total}</strong> of{" "}
          <strong className="tabular-nums">{total}</strong>
        </span>
      )}
    </div>
  );
}
